import { render, staticRenderFns } from "./ViewSuppliers.vue?vue&type=template&id=33e12684&"
import script from "./ViewSuppliers.vue?vue&type=script&lang=js&"
export * from "./ViewSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./ViewSuppliers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports